/**
 * Block-for-block skeleton for `/orders/family/print` (PROD-1064): the
 * print-hidden toolbar, then one portrait sheet with the student header, the
 * meal column headings and five weekday rows. Matches `family-print.tsx` so
 * the swap to the real pages does not jump.
 */

import { Skeleton } from '@ordo/ui/skeleton'

export function FamilyPrintSkeleton() {
  return (
    <div className="min-h-dvh bg-neutral-100" aria-busy="true" aria-label="Loading your print">
      <div className="border-b bg-white px-4 py-3">
        <div className="mx-auto flex max-w-[11in] items-center justify-between gap-3">
          <Skeleton className="h-4 w-72" />
          <Skeleton className="h-8 w-20" />
        </div>
      </div>
      <div className="overflow-x-auto px-4 py-6">
        <div className="mx-auto flex min-h-[11in] w-[8.5in] flex-col bg-white p-[0.5in] shadow-sm ring-1 ring-black/10">
          <div className="flex items-end justify-between gap-6 border-b-2 border-neutral-200 pb-3">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-8 w-48" />
              <Skeleton className="h-4 w-64" />
            </div>
            <div className="flex flex-col items-end gap-1">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-4 w-16" />
            </div>
          </div>
          <div className="grid grid-cols-[112px_repeat(2,minmax(0,1fr))] gap-x-6 pb-2 pt-4">
            <span />
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-3 w-16" />
          </div>
          {Array.from({ length: 5 }, (_, i) => (
            <div
              key={i}
              className="grid min-h-[136px] grid-cols-[112px_repeat(2,minmax(0,1fr))] gap-x-6 border-t border-neutral-200 py-4">
              <div className="flex flex-col gap-1.5">
                <Skeleton className="h-6 w-24" />
                <Skeleton className="h-4 w-20" />
              </div>
              <div className="flex flex-col gap-1.5">
                <Skeleton className="h-5 w-40" />
                <Skeleton className="h-4 w-28" />
              </div>
              <div className="flex flex-col gap-1.5">
                <Skeleton className="h-5 w-44" />
                <Skeleton className="h-4 w-36" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
